import { Dialog, Icon, TextHtml } from 'ui';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';

const DialogNotes = ({ t, open, onClose, notes }) => {
  return (
    <Dialog
      ariaLabel={t('assigments:Teacher notes')}
      className={'dialog-notes'}
      isCloseButtonHidden
      isOpen={open}
      onClose={onClose}
      size="all-screen"
    >
      <div className="dialog-notes__header">
        <div className="dialog-notes__header-left">
          <Icon name="teacher" size="xl" color="blue-400" />
          <span className="dialog-notes__header-title">{t('assigments:Teacher notes')}</span>
        </div>

        <button type="button" aria-label={t('actions:Close')} onClick={onClose}>
          <Icon name="close" color="black" />
        </button>
      </div>
      <div className="dialog-notes__content">
        <TextHtml text={notes} />
      </div>
    </Dialog>
  );
};

DialogNotes.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  notes: PropTypes.string,
};

DialogNotes.defaultProps = {
  onClose: function () {},
  open: false,
};

export default withTranslation(['course', 'actions', 'assigments'])(DialogNotes);
